<h2 class="mb-1" mat-dialog-title>{{'PARKIFLY.FORM.QUALITY_CANCELLED_HOTEL_STAY' | transloco}}</h2>
<mat-dialog-content>
    <p>{{'PARKIFLY.FORM.QUALITY_CANCELLED_HOTEL_STAY_TEXT' | transloco}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>{{ 'FORM.TERMSDIALOGCLOSE' | transloco }}</button>
</mat-dialog-actions>